<script setup lang="ts">
    interface MemberGalleryProps {
        data: MemberGalleryData;
    }

    const props = defineProps<MemberGalleryProps>();

    const isMaxMd = ref(false);

    useMediaQuery([
        {
            query: defaultQueries.max.md,
            ref: isMaxMd,
        },
    ]);
</script>
<template>
    <mol-section
        class="mol-member-gallery"
        :background-image="data.style?.background_image"
        :background-image-mobile="data.style?.background_image_mobile">
        <atm-container class="relative z-1 py-10 md:py-20">
            <div class="grid aspect-2/1 grid-flow-col grid-cols-4 grid-rows-2 gap-1 md:gap-2">
                <template
                    v-for="(image, index) in data.images.slice(0, 6)"
                    :key="index">
                    <atm-account-card
                        :content="isMaxMd"
                        :class="[
                            'mb-1 md:mb-2',
                            {
                                '-translate-y-8 md:-translate-y-24': [0, 1].includes(index),
                                'translate-y-8 md:translate-y-24': [3, 4].includes(index),
                                'row-span-2': [2, 5].includes(index),
                            },
                        ]"
                        no-padding
                        content-no-padding>
                        <atm-image
                            :data="image"
                            class="h-full"
                            cover
                            :preset="[2, 5].includes(index) ? '2to3' : '1to1'" />
                    </atm-account-card>
                </template>
            </div>
        </atm-container>
    </mol-section>
</template>
